
<template>
  <div class="cntnt">

<div id="general">

    <h1 class="heading">  General FAQ</h1>
    <p class="content">
      <div role="tablist">

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="secondary" class="text-left">
              #1. How electricity tariff is determined? Who determines the electricity tariff?
                        </b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">Electricity tariff is fixed by the Assam Electricity Regulatory Commission (AERC).
                 Assam Power Distribution Company Limited (APDCL) makes an annual or three years assessment of the revenue
                 requirement based on cost of power purchase, operation & maintenance, employees' salary, administrative &
                 general expenditure and files a petition before the AERC for fixation of the tariff for different categories
                 of consumers. AERC fixes the tariff after public hearing where all the stakeholders are involved.</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="secondary" class="text-left">
            #2. What is Fuel & Power Purchase Price Adjustment (FPPPA) charge? Does APDCL have the authority to levy FPPPA charge?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">Tariff is generally revised once in a year.
                FPPPA charge is levied to take care of the increase in fuel cost to generating company
                and consequent increase in power purchase price by the distribution companies during the year
                 after fixation of the tariff for the year. APDCL has the authority to levy FPPPA charge as per
                  the provision of the AERC (Fuel and Power Purchase Price Adjustment Formula) Regulations,
                  2010 notified by the Commission under section 62(4) and 181 of the Electricity Act 2003.</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3 variant="secondary" class="text-left">
            #3. Why the present FPPPA charge of 69 paise/unit is levied?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                In June 2010, Central Govt. enhanced the price of APM and Non-APM natural gas by 119% and 58% respectively.
                APDCL gets 48% of average power supply from gas based power stations, the generating stations have been raising
                their bills considering revise price of gas. The impact of the price hike in natural gas as well as revision of
                 tariff by Central Electricity Regulatory Commission has added incremental cost to APDCL on account of power
                 purchase which need to be recovered by levying FPPPA charge of 69 paise/unit. The entire amount recoverable by
                  levying FPPPA charges is for making payment to the generating companies for supplying power to APDCL at
                  increased price. This is not to compensate any other loss.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-4 variant="secondary" class="text-left">
            #4. What is Transmission & Distribution (T&D) loss?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-4" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                The sum total of 'Technical' and 'Commercial' losses are termed as Transmission & Distribution (T&D) Loss.
                Technical Loss: Every element in a power System (a line or a transfomer etc) offers resistance to power flow
                and thus consumes some energy while performing the duty expected of it.The cumulative energy consumed by all
                these elements is classified as "Technical Loss." Commercial Loss: Losses occur on account of non-performing
                and under performing meters, wrong applications of multiplying factors, defects in CT & PT circuitry, meters
                not read, pilferage by manipulating or by passing of meters, theft by direct tapping etc. These are all due to
                 non-metering of actual consumption and are called commercial losses.The total of "Technical" and "Commercial"
                  losses are termed are T&D loss.It is unfortunate that in addition to the above, there is also a loss in revenue
                   due to non-realisation of billed demand.This is in addition to commercial losses and the aggregate of T&D loss
                    and revenue loss due to non-realisation is termed as "AT&C loss" (Aggregate technical and Commercial loss).
                    Therefore AT&C loss to the utility is the sum total of technical loss, commercial losses and shortage due to
                     non-realisation of total billed demand.
                     Example:

                     Units Input	100 MU	Revenue collection with
                     reference to billed demand	90%
                     Unit billed	70 MU	This means out of 70 MU sales
                     realization is for 90% of 70MU	63%
                     T & D Losses	30 MU	ATC losses	37%

                     Aggregate Technical and Commercial (AT&C) losses, which include theft, non-billing,
                     incorrect billing, inefficiency in collection, and transmission and distribution losses.
                     AT&C losses are calculated as follows:
                     (1 – ATC Loss) = (1 – T&D Loss) x (Collection Efficiency) = [(Units billed)/(Units input)] x
                     [(Rupees realised)/(Rupees billed)]
                     There is another interpretation of this formula. Rearrange the two terms in parentheses on the right hand side as
                      follows: = [(Rupees realised)/(Units input)] x [(Units billed)/(Rupees billed)] The first term in square
                      brackets is the "Average Realisation Rate".
                     The inverse of the second term is the "Average Billing Rate".
                     Therefore, (1 – ATC Loss) = (Average Realisation Rate)/ (Average Billing Rate) .
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-5 variant="secondary" class="text-left">
              #5. What measures APDCL has taken to reduce Technical & Commercial loss?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
              <ol>
                <li>Replacement of stopped and defective meters regularly</li>
                <li>Installation of checked meters in industrial houses & high power consuming customers</li>
                <li>Massive disconnection drive</li>
                <li>Use of computerized systems for metering & billing</li>
                <li>Infrastructure development through R-APDRP, Chief Minister's Power Supply Assurance Mission,
                  Assam Bikash Yojana, ADB financed schemes etc.</li>
                <li>Creation of 12 special police stations ? Creation of 24-hour
                  'Central Electricity Theft Control Centre' at Guwahati (Dial 96780-05171)</li>
                <li>Handing over of rural distribution feeders to franchisees for improved collection and service.</li>
              </ol>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-6 variant="secondary" class="text-left">
            #6. Has the T&D loss of APDCL decreased in the last few years? What is the T&D loss target fixed by AERC?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                Yes, the T&D loss of APDCL has been decreasing significantly in view of the steps taken by the company
                 as a part of Reform Programme.
                 <ul>
                 <li>2003-04 :      39%</li>
                 <li>2004-05 :     37%</li>
                 <li>2005-06 :     32%</li>
                 <li>2006-07 :   31%</li>
                 <li>2008-09 :    27.5%</li>
                 <li>2009-10 :     26.5%</li>
                 <li>2010-11 :     25%</li>
                 </ul>
                 The distribution loss of APDCL is 25%, but the overall T&D loss of the state taking into account
                 of the transmission loss of Assam Electricity Grid Corporation Limited is 28% against the national
                  average T&D loss of 30% in the FY of 2010-11. AERC has fixed the T&D loss target to APDCL is 24.17%
                  in the FY 2011-12 as per tariff order 2010-2013. Only the loss approved by AERC can be passed on to
                  the consumers. The rest of the loss must be absorbed by APDCL itself.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-7 variant="secondary" class="text-left">
              #7. Why the power tariff of Assam is higher than most of the states of India?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-7" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                <ol>
                  <li>Cost of distribution is high because of the extensive network of difficult terrain.</li>
                  <li>Domestic consumers constitute 88% of the total consumers.</li>
                  <li>Low Voltage consumption constitutes more than 50% of the total consumption.</li>
                  <li>Quantum of energy handled is less in comparison with states with higher population.
                     For example, West Bengal State Electricity Distribution Company Limited with 22000 employees
                     handles average 30000 Million Units per year whereas APDCL with 14525 employees handles only
                     5000 Million Units.Therefore fixed cost per unit in APDCL is around 25% whereas it is only 10%
                     in case of WBSEDCL</li>
                </ol>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-8 variant="secondary" class="text-left">
            #8. Is the number of employees in APDCL very high?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-8" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                The total employees of ASEB in 1980-81 were 22822 to handle less than 300 MW. In 2002-03,
                the manpower was 17316 to handle 500 MW peak load. But the present manpower strength of successor
                companies of ASEB to handle 1100 MW is 14525 including 11232 nos. of APDCL.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-9 variant="secondary" class="text-left">
              #9. What are the usual sources of power for APDCL and Average quantum of Supply?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-9" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                <table border="">
                  <tr>
                    <th>Company</th>
                    <th>Allotment</th>
                    <th>Avg Availability (Off-Peak)</th>
                    <th>Avg Availability (Peak)</th>
                  </tr>
                  <tr>
                    <td>NEEPCO </td><td>558 MW</td><td>469 MW</td><td>347 MW</td>
                  </tr>
                  <tr>
                    <td>NHPC</td><td>31 MW</td><td>25 MW</td><td>30 MW</td>
                  </tr>
                  <tr>
                  </tr>
                  <td>NTPC</td><td>162 MW</td><td>70 MW</td><td>10 MW</td>
                  <tr>
                    <td>APGCL</td><td>340 MW</td><td>175 MW</td><td>265 MW</td>
                  </tr>
                  <tr>
                    <td>Other Source</td><td>28.5 MW</td><td>11 MW</td><td>11 MW</td>
                  </tr>
                  <tr>
                    <td>Total Allotment</td><td>1119.5 MW</td><td>628 MW</td><td>885 MW</td>
                  </tr>
                </table>

              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-10 variant="secondary" class="text-left">
              #10. What is the shortfall in availability of power? What measures has APDCL taken to meet the shortfall?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-10" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                Day to day availability depends upon water discharge into the rivers, gas/coal availability &
                availability of machines. As such APDCL does not receive the entire allotted power.
                 Hence APDCL is always experiencing a shortfall to the tune of 30–70 MW in off peak and 200-250 MW
                in the peak load hours. To meet this shortfall on the average 150 MW at peak hours have been purchased
                 from Power Exchange continuously at high rates.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-11 variant="secondary" class="text-left">
              #11. What is the projected demand for power in the next five years? Will the power situation improve in the future?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-11" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                The Central Electricity Authority projects the peak power demand to be 1134 MW in the current year
                i.e. 2011-12. By 2015-16, the demand is expected to reach 1606 MW.
                <br>
                However, the power situation of Assam is likely to improve by the year 2012, when APDCL will receive
                additional 240 MW, 120 MW each from Bongaigaon TPS & Palatana TPS respectively.Along with other
                 sources the availability of power is expected to increase by an additional 300 MW by the end of 2012.
                  It is also expected to receive additional 300 MW in 2013 from the two power stations mentioned above.
                </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-12 variant="secondary" class="text-left">
              #12. Is it true that Government establishments are billed on lump-sum basis? Do they pay their electricity bills?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-12" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                Government establishments are not billed on lump-sum basis. APDCL has been raising electricity bills
                to Government establishments on the basis of energy meter readings.Thus through individual metering
                power consumption of all Govt. establishments is accounted and paid for. However, the State Government
                 may provide electricity internally to some of the consumers on lump-sum basis but this action does
                 not impact the power tariff.
                 <br>
                The Government of Assam pays a fixed amount of Rs. 6 crore in advance every month on a regular basis
                which is adjusted against the actual billing amount. If the actual amount is more than this fixed
                payment, the remaining amount is kept outstanding. As on 31st March 2011, an arrear of Rs. 52 crore
                 is outstanding as dues to be paid by the Government. The State Government has provided for the amount
                  in the budget of 2011-12 to be paid to APDCL.
               </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-13 variant="secondary" class="text-left">
            #13. What are the reasons of power failure/frequent tripping? What measures have APDCL taken to reduce it?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-13" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                <ol>
                  <li>Load shedding due to non-availability of power</li>
                  <li>In spite of vast improvement distribution network still fragile</li>
                  <li>Preventive/break down maintenance</li>
                  <li>Line fault due to break down of line material</li>
                  <li>Transient fault on the line</li>
                  <li>Overloading of the equipments</li>
                  <li>Breakdown of circuit breaker, CT, PT etc.</li>
                  <li>Sabotage by miscreants etc.</li>
                </ol>
                <br>
                To reduce frequent tripping, the sub-transmission & distribution system of APDCL is being upgraded
                under different projects sponsored by State/Central Govt. like ADB (Phase II), R-APDRP, Assam Bikash
                 Yogana, Additional Central Assistance, Trade Development Fund and Chief Minister's Power Supply
                 Assurance Mission etc. under Annual Plan. After completion of the projects, most of the unscheduled
                  tripping can be avoided.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-14 variant="secondary" class="text-left">
            #14. Why APDCL does not give advance notice for Load Shedding/tripping?
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-14" visible accordion="my-accordion" role="tabpanel">
            <b-card-body >
              <b-card-text class="text-left">
                All efforts are made to give advance notice but on many occasions sudden load shedding becomes absolutely
                necessary to prevent grid collapse or maintain the system. Fragile infrastructure and weather conditions also
                 cause tripping. However, as mentioned above APDCL is making its best efforts and taking necessary steps to
                 reduce unscheduled load shedding or tripping.  </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </p>
  </div>
<br>

<div id="mybijulee">
  <h1 class="heading">FAQ About My Bijulee App</h1>
  <p class="content">
    <div role="tablist">

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-15 variant="secondary" class="text-left">
            #1. How to download the 'myBijulee' App?
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-15" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
            You can download the 'myBijulee' App from Google’s Play Store.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-16 variant="secondary" class="text-left">
          #2. Is the App available for other platforms such as iOS or Windows?
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-16" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
          Presently the App is available for Android Platform only.
          The other versions are under development and will be available soon.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-17 variant="secondary" class="text-left">
            #3. What are the functionalities available in the App?
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-17" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
              Following functionalities are available for registered users:
              <ol>
              <li>User Info – Users can view their consumer particulars.</li>
              <li>View Bill – Users can view their latest as well as last 6 months bills.</li>
              <li>Pay Bill – Users can pay online their latest bill.</li>
              <li>Consumption History – Users can view their last 6 months consumption history.</li>
              <li>Payment History – Users can view their last 6 months payment history.</li>
              <li>Update Profile – Users can update their particulars such as mobile number, e-mail etc.</li>
              <li>Raise Complaint – Users can raise different type of complaints through the app itself.</li>
              <li>Complaint Details – Users can also track the status of their previously raised complaints.</li>
              <li>Prepaid Payment – Prepaid meter users can recharge online through this app.</li>
              <li>Voucher Details – Prepaid users can view their voucher code online through this app.</li>
              </ol>
              Following functionalities are available for guest users:
              <ol>
              <li>Pay Postpaid bills.</li>
              <li>View Postpaid bills.</li>
              <li>Prepaid meter recharge.</li>
              <li>View voucher codes for Prepaid Meters.</li>
              <li>Register for a new service connection.</li>
            </ol>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-18 variant="secondary" class="text-left">
          #4. How to register in the App?
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-18" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
              For already registered consumers of APDCL portal, the initial user name and password will be the
              consumer number.
              <br>
              For such consumers who are not yet registered in APDCL portal, the user has to create a new account
              in the App.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-19 variant="secondary" class="text-left">
        #5. I have registered in the App, but cannot lodge complaint through the App.
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-19" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
            The complaint registration facility is available only for R-APDRP consumers
            (i.e. consumers having consumer number of 11 digits).
            For other consumers such as Non-RAPDRP and Prepaid consumers, the complaint could be lodged by calling '1912'.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-20 variant="secondary" class="text-left">
          #6. I have made bill payment through the App, but the same is not showing in payment history.
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-20" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
            If any consumer has made payment through the App, it takes around sometime to update the payment in system.
            Once the payment is updated in the system, it will be shown in the App.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-21 variant="secondary" class="text-left">
          #7. I have made an online recharge through the App. But the vend code (voucher code) has not been generated.
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-21" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
          Normally, the vend code is automatically available in the App itself after the payment is made.
          However, sometimes due to delay in confirmation from Bank side, it takes some time to generate the vend code.
           In that case, the user can check the voucher code after some time in the App itself.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-22 variant="secondary" class="text-left">
          #8. If I face any difficulties in using the App, where to complain?
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-22" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="text-left">
            If you face any difficulties in using the App or you have some doubts regarding the App,
            then you can mail to support@apdcl.org with your consumer number and necessary screenshots, if necessary.
             Alternately, you can call at '1912' also for any issues with the App.
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
  </p>
</div>
<br><br><br><br><br><br><br><br><br><br>

</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.8rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;
}
@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .content{
    /* margin-right: 60px; */
  }
  }

</style>


<script>
  export default {
    data() {
      return {
        text: ""

      }
    }
  }
</script>
